jQuery(document).ready(function($){
	$('.datepicker').datepicker({
		dateFormat: 'm/d/yy'
	});

	$('.report-filters input[type="checkbox"]').on('change', disableCsvButton);

	$('.date-field .datepicker').on('change', function(){
		disableCsvButton();

		let fiscalPeriodDropdown = $('select#fiscal_period');
		let optionDateStr = fiscalPeriodDropdown.find('option[value="' + fiscalPeriodDropdown.val() + '"]').attr('dates');

		let fieldDateStr = $('input#start_date').val() + '__' + $('input#end_date').val();

		if(optionDateStr != fieldDateStr) {
			fiscalPeriodDropdown.val('');
		}
	});

	$('select#fiscal_period').on('change', function(){
		let option = $(this).find('option[value="' + $(this).val() + '"]');
		let dates = option.attr('dates');

		if(typeof dates !== 'undefined' && dates !== false) {
			let dateArr = dates.split('__');

			$('input#start_date').val(dateArr[0]);
			$('input#end_date').val(dateArr[1]).trigger('change');
		} else {
			$('input#start_date').val('');
			$('input#end_date').val('').trigger('change');
		}
	});

	$('.submit-disabled-message .update-filters-link').on('click', function(){
		$('#report-filters').submit();
	});

	$('.report-filters .expand-button').on('click', function(){
		expandDiv($(this), '.report-filters');
	});

	$('.commission .expand-button').on('click', function(){
		expandDiv($(this), '.commission');
	});

	function disableCsvButton() {
		$('#download-commission-report button').prop('disabled', true).closest('.submit').addClass('disabled');
	}

	function expandDiv(el, selector) {
		let target = el.closest(selector);
		let wasExpanded = target.hasClass('expanded');
		$(selector).each(function(){
			$(this).removeClass('expanded');
		});
		if(!wasExpanded) target.addClass('expanded');		
	}

	$('body:not(.report-printable-page) .commission-info.admin-row').on('click', function(e){
		if($(e.target).attr('type') != 'checkbox' && !$(e.target).hasClass('expand-button')) {
			$(this).find('input[type="checkbox"]').each(function(){
				let wasChecked = $(this).prop('checked');
				$(this).prop('checked', !wasChecked).trigger('change');
			});
		}
	});

	$('.commission-info.admin-row input[type="checkbox"]').on('change', function(){
		let isChecked = $(this).prop('checked');
		if(isChecked) {
			$(this).closest('.commission-info.admin-row').addClass('checked');
		} else {
			$(this).closest('.commission-info.admin-row').removeClass('checked');
		}
	});

	// $('#commission-location-filter').on('change', function(){
	// 	let value = $(this).val();
	// 	console.log(value, value.length, value.length > 0);
	// 	window.location.href = value.length > 0 ? '/commission-report/?location_filter=' + value : '/commission-report/';
	// });

	$('.filter-wrapper .clear-filter').on('click', function(){
		let parentDiv = $(this).closest('.filter-wrapper');

		if(parentDiv.hasClass('dates')) {
			parentDiv.find('input').each(function(){
				$(this).val('');
			});
			parentDiv.find('select').each(function(){
				$(this).val('');
			});
		} else {
			parentDiv.find('input[type=checkbox]').each(function(){
				$(this).prop('checked', false);
			});
		}
	});

	$('a.scfe-cta-button.update-payment-status').on('click', function(e){
		e.preventDefault();

		const wasShowing = $(this).closest('.commission-report').hasClass('show-payment-options');

		if(wasShowing) {
			$(this).html('Update Payment Status').closest('.commission-report').removeClass('show-payment-options');
		} else {
			$(this).html('Close').closest('.commission-report').addClass('show-payment-options');
		}
	});

	$('.commission-report .payment-options input[name="payment_type"]').on('change', function(){
		if($(this).val()) {
			$(this).closest('.payment-options').find('button').attr('disabled', false);
		}
	});


	$('body:not(.report-printable-page) .commission-report .commission-year-details').on('click', function(e){
		if(!isHeaderButton(e)) $(this).closest('.commission-year').toggleClass('collapsed');
	});

	$('body:not(.report-printable-page) .commission-report .commission-quarter-details').on('click', function(e){
		if(!isHeaderButton(e)) $(this).closest('.commission-quarter').toggleClass('collapsed');
	});

	$('body:not(.report-printable-page) .commission-report .commission-month-details').on('click', function(e){
		if(!isHeaderButton(e)) $(this).closest('.commission-month').toggleClass('collapsed');
	});

	$('body:not(.report-printable-page) .commission-report span.toggle-unpaid').on('click', function(){
		const parentDiv = $(this).closest('span.toggle-unpaid');
		const isSelected = parentDiv.hasClass('selected');
		if(isSelected) {
			parentDiv.removeClass('selected') 
		} else {
			parentDiv.addClass('selected');
		}

		const selector = isSelected ? '.commission-info.unpaid.checked' : '.commission-info.unpaid:not(.checked)';
		const unpaidCommissions = $(this).closest('.commission-group').find(selector);
		unpaidCommissions.each(function(){
			$(this).trigger('click');
		});
	});

	$('body:not(.report-printable-page) .commission-report .check-all-unpaid-commissions').on('click', function(e){
		e.preventDefault();

		const isSelected = $(this).hasClass('selected');
		const selector = isSelected ? 'span.toggle-unpaid.selected' : 'span.toggle-unpaid:not(.selected)';
		if(isSelected) {
			$(this).removeClass('selected') 
		} else {
			$(this).addClass('selected');
		}

		$(selector).each(function(){
			$(this).trigger('click');
		});	
	});


	function isHeaderButton(e) {
		const headerButtons = [
			'a.print-report',
			'span.toggle-unpaid',
		];

		let isHeaderButton = false;
		$.each(headerButtons, function(index, button){
			if($(e.target).closest(button).length) isHeaderButton = true;
		});

		return isHeaderButton;
	}


	if($('#print-commission-report').length) {
		$('#print-commission-report').on('click', generateHtmlPdf);

		function generateHtmlPdf() {
			const { jsPDF } = window.jspdf;
			const doc = new jsPDF({
				unit: 'pt',
				format: 'letter',
				orientation: 'portrait'
			});

			const pxMultiplier = 72;
			const wrapper = document.getElementById('commission-report-print-wrapper');
			const heading = document.getElementById('commission-report-print-heading');

			wrapper.style.width = 900;

			const pageWidth = doc.internal.pageSize.getWidth();

			setTimeout(function(){
				doc.html(wrapper, {
					callback: function (doc) {
						const filename = $('#commission-report-filename').val();
						doc.save(filename);
					},
					margin: 0.25 * pxMultiplier,
					x: 0.25 * pxMultiplier,
					y: 0.25 * pxMultiplier,
					html2canvas: {
						scale: pageWidth / wrapper.offsetWidth * 6.5 / 7.5,
						useCORS: true,
					},
					width: pageWidth
				});
			}, 100);
		}
	}
});